import { generateOrderSummary } from '../utils/generateOrderSummary.js';

/**
 * Sends a free order (0 Euro) to the Drupal backend for processing.
 *
 * This method sends the order containing user tokens for validation.
 * The backend will verify if the user is authenticated and process the order if the total is 0.
 *
 * @param {Order} order - The order object, which contains details like items, total amount, etc.
 * @throws {Error} - Throws an error if the order fails to send or if the verification fails.
 */
export async function sendFreeOrderToEventive(order) {
  try {
    const response = await fetch('/eventive-api/create-free-event-data-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        eventOrder: order,  // Send the order details with userToken contains.
        debug: false,
      }),
    });

    if (!response.ok) {
      console.error(`sendFreeOrderToEventive: Error fetching events: ${response.statusText}`);
      return null;
    }

    const orderData = await response.json();
    generateOrderSummary(orderData);
    // console.trace('sendFreeOrderToEventive: Order successfully Response:', orderData);

  } catch (error) {
    console.error('sendFreeOrderToEventive: Order error Response:', error);
    alert('Failed to place the order. Please try again.');
  }
}
